function cov_131ewvcylm() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Levels.tsx";
  var hash = "4aa02dde151ad8b2ae0c17d7ff55610c67232ad2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Levels.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4aa02dde151ad8b2ae0c17d7ff55610c67232ad2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_131ewvcylm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_131ewvcylm();
var Icon = (cov_131ewvcylm().s[0]++, {
  name: 'levels',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 10.3016L12 5.05164L4.5 10.3016V11.5H19.5V10.3016ZM22 9.52066V13C22 13.5523 21.5523 14 21 14H3C2.44772 14 2 13.5523 2 13V9.52066C2 9.19434 2.15921 8.88855 2.42654 8.70143L11.4265 2.40143C11.7709 2.1604 12.2291 2.1604 12.5735 2.40143L21.5735 8.70143C21.8408 8.88855 22 9.19434 22 9.52066Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 17.5V19.5H19.5V17.5H4.5ZM3 15C2.44772 15 2 15.4477 2 16V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V16C22 15.4477 21.5523 15 21 15H3Z\" fill=\"currentColor\"/>"
});
export default Icon;